import {
  Box,
  BoxProps,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { Clear } from '@mui/icons-material';
import { useAtom } from 'jotai';
import { selectedWbsFilter as selectedWbsFilterAtom } from '../../state';
import { WorkpackWbsFilterOption } from '@/__generated__/graphql';
import { enumToString } from '@/utils/string';
import { usePersistKpiFilters } from '../../hooks/usePersistKpiFilters';

type Props = {} & BoxProps;

const OPTIONS: WorkpackWbsFilterOption[] = [
  WorkpackWbsFilterOption.Fm,
  WorkpackWbsFilterOption.Other,
  WorkpackWbsFilterOption.Na,
];

const formatOptions = (option: WorkpackWbsFilterOption) => {
  switch (option) {
    case WorkpackWbsFilterOption.Fm:
      return 'FM';
    case WorkpackWbsFilterOption.Other:
      return 'Other';
    case WorkpackWbsFilterOption.Na:
      return 'N/A';
    default:
      return enumToString(option);
  }
};

export const KpiWbsFilterButton = ({ ...rest }: Props) => {
  const [selectedWbsFilter, setSelectedWbsFilter] = useAtom(selectedWbsFilterAtom);
  const { persistSelectedWbsFilter, loading } = usePersistKpiFilters();

  const handleChange = (event: SelectChangeEvent) => {
    const value = event.target.value as WorkpackWbsFilterOption;

    persistSelectedWbsFilter(value).then(() => {
      setSelectedWbsFilter(value);
    });
  };

  const handleClear = (event: React.MouseEvent) => {
    event.stopPropagation();
    persistSelectedWbsFilter(undefined).then(() => {
      setSelectedWbsFilter(undefined);
    });
  };

  return (
    <Box {...rest}>
      <Select
        disabled={loading}
        variant="outlined"
        value={selectedWbsFilter ?? ''}
        displayEmpty
        renderValue={(selected) => {
          if (!selected) return 'Select WBS';
          return formatOptions(selected as WorkpackWbsFilterOption);
        }}
        sx={{ maxHeight: '3.5rem', width: 140 }}
        onChange={handleChange}
        id="kpi-tracker-wbs-filter-button"
        endAdornment={
          selectedWbsFilter && (
            <InputAdornment
              position="end"
              sx={{
                position: 'absolute',
                right: 25,
                pointerEvents: 'none',
              }}
            >
              <IconButton
                size="small"
                onClick={handleClear}
                disabled={loading}
                aria-label="clear selection"
                sx={{ pointerEvents: 'auto' }}
              >
                <Clear fontSize="small" />
              </IconButton>
            </InputAdornment>
          )
        }
      >
        {OPTIONS.map((option) => (
          <MenuItem key={option} value={option}>
            {formatOptions(option)}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
